// extracted by mini-css-extract-plugin
export default {"info":"OrgsFilterInfo_info__aLu-A","placeHolderShimmer":"OrgsFilterInfo_placeHolderShimmer__Ix8p9"};